import React, { useEffect, useState } from "react";
import { Breadcrumb } from "react-bootstrap";
import Graybg from "../../UI/Graybg";
import DataTable from "./DataTable/Table";
import userService from "../../app/services/user.service";
import { toast } from "react-toastify";
import Loader from "../../UI/loader/loader";
import Toast from "../../UI/Toast/Toast";

const OTPList = () => {
  const [otpData, setOtpData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const getOtpData = ({ loader }) => {
    loader && setLoading(true);

    userService
      .getOTPList()
      .then((res) => {
        loader && setLoading(false);

        // Success case
        setErrorMessage("");
        setOtpData(res?.data?.data || []);
      })
      .catch((error) => {
        loader && setLoading(false);

        console.log(error.response.data);

        // 🔥 Backend 500 error message
        const apiMessage =
          error?.response?.data?.message ||
          "You are not authorized to see OTP List.";

        setErrorMessage(apiMessage);
        setOtpData([]);

        toast.error(apiMessage);
      });
  };

  useEffect(() => {
    getOtpData({ loader: true });
  }, []);

  return (
    <div className="section">
      {loading && <Loader />}
      <Toast />

      <div className="d-flex justify-content-between align-items-center">
        <div>
          <h4>OTP List</h4>
          <Breadcrumb>
            <Breadcrumb.Item active>OTP List</Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <Graybg>
        {errorMessage ? (
          <div className="alert alert-danger text-center fw-bold py-4">
            {errorMessage}
          </div>
        ) : (
          <DataTable otpData={otpData} />
        )}
      </Graybg>
    </div>
  );
};

export default OTPList;
